import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

@Injectable({
    providedIn: 'root'
})
export class ToastService{
    constructor(private messageService:MessageService){}
    show({severity,summary,detail}:{severity:string,summary:string,detail:string}){
         this.messageService.add({
            severity,
            summary,
            detail,
            life: 5000
        })
    }
}